// extracted by mini-css-extract-plugin
export default {"container":"GDPR_container__-5Jr1","title":"GDPR_title__gRrGh"};